import React from "react";

import EmpoweredConversations from "../components/EmpoweredConversations";

const ProjectsPage = () => {
	return (
		<div>
			<EmpoweredConversations />
		</div>
	);
};

export default ProjectsPage;
